import { Link } from "react-router";
import {
  IButtonProps,
  ILinkButtonProps,
  IRouterLinkButtonProps,
  ThemeColor,
  ThemeSize,
} from "../interfaces/types";

export function Button(props: IButtonProps) {
  const {
    subtle,
    outline,
    color,
    transparent,
    size,
    icon,
    className,
    fullWidth,
    children,
    ...rest
  } = props;
  return (
    <button
      {...rest}
      className={getClassNames(
        subtle,
        outline,
        color,
        transparent,
        size,
        icon,
        className,
        fullWidth,
      )}
    >
      {children}
    </button>
  );
}

export function LinkButton(props: ILinkButtonProps) {
  const {
    subtle,
    outline,
    color,
    transparent,
    size,
    icon,
    className,
    fullWidth,
    children,
    ...rest
  } = props;
  return (
    <a
      {...rest}
      className={getClassNames(
        subtle,
        outline,
        color,
        transparent,
        size,
        icon,
        className,
        fullWidth,
      )}
    >
      {children}
    </a>
  );
}

export function RouterLinkButton(props: IRouterLinkButtonProps) {
  const {
    subtle,
    outline,
    color,
    transparent,
    size,
    icon,
    className,
    fullWidth,
    children,
    ...rest
  } = props;
  return (
    <Link
      {...rest}
      className={getClassNames(
        subtle,
        outline,
        color,
        transparent,
        size,
        icon,
        className,
        fullWidth,
      )}
    >
      {children}
    </Link>
  );
}

const getClassNames = (
  subtle: boolean | undefined,
  outline: boolean | undefined,
  themeColor: ThemeColor | undefined,
  transparent: boolean | undefined,
  size: ThemeSize | undefined,
  icon: boolean | undefined,
  className: string | undefined,
  fullWidth: boolean | undefined,
) => {
  return `btn btn-${outline ? "outline-" : ""}${themeColor}${
    subtle ? "-subtle" : ""
  }${transparent ? " btn--transparent" : ""}${size ? ` btn-${size}` : ""}${
    icon ? ` btn--icon` : ""
  }${fullWidth ? ` w-100` : ""}${className ? ` ${className}` : ""}`;
};
